import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { IdCard, Loader2, Check } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { insApi, errMsg } from "../../lib/insApi";

const Row = ({ e, onDone }) => {
  const [iq, setIq] = useState("");
  const [exp, setExp] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const r = await insApi.borderToIqama(e.id, { iqama_number: iq, iqama_expiry: exp });
      toast.success(r.policies_notified.length ? `تم تحديث ${e.name} وإبلاغ مزود البوليصة ${r.policies_notified.join("، ")}` : `تم تحديث رقم إقامة ${e.name}`);
      onDone();
    } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl bg-white p-2.5" data-testid={`border-pending-${e.id}`}>
      <div className="min-w-[160px] flex-1">
        <p className="text-sm font-semibold">{e.name}</p>
        <p className="text-xs text-slate-500">حدود <span dir="ltr">{e.border_number}</span> · منذ {e.days} يوم{e.policies.length ? ` · بوليصة ${e.policies.join("، ")}` : ""}</p>
      </div>
      <Input data-testid={`border-iqama-${e.id}`} dir="ltr" inputMode="numeric" maxLength={10} placeholder="رقم الإقامة الجديد" value={iq} onChange={(x) => setIq(x.target.value)} className="h-9 w-40" />
      <Input data-testid={`border-iqama-expiry-${e.id}`} type="date" title="انتهاء الإقامة (اختياري)" value={exp} onChange={(x) => setExp(x.target.value)} className="h-9 w-40" />
      <Button size="sm" data-testid={`border-iqama-save-${e.id}`} disabled={!/^[12]\d{9}$/.test(iq.trim()) || busy} onClick={save} className="gap-1 bg-amber-600 hover:bg-amber-700">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />} تحديث الملف والبوليصة</Button>
    </div>
  );
};

export const BorderPendingAlert = ({ onUpdated }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => insApi.borderPending().then((r) => setItems(r.items)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!items.length) return null;
  return (
    <div className="space-y-2 rounded-2xl border border-amber-200 bg-amber-50 p-3" data-testid="border-pending-alert">
      <p className="flex items-center gap-1.5 text-sm font-bold text-amber-900"><IdCard className="h-4 w-4" /> {items.length} موظف مسجّل برقم الحدود — إذا صدرت إقامته اكتب رقمها لتحديث ملفه وبوليصته بضغطة</p>
      {items.map((e) => <Row key={e.id} e={e} onDone={() => { load(); onUpdated?.(); }} />)}
    </div>
  );
};
